import { render, staticRenderFns } from "./VeJwJingsaiBaomingList.vue?vue&type=template&id=62a0164f&scoped=true"
import script from "./VeJwJingsaiBaomingList.vue?vue&type=script&lang=js"
export * from "./VeJwJingsaiBaomingList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62a0164f",
  null
  
)

export default component.exports